
import { useState } from "react";
import { ProPageSEO } from "@/components/pro/ProPageSEO";
import { ProPageContent } from "@/components/pro/ProPageContent";

const Pro = () => {
  const [showWaitlist, setShowWaitlist] = useState(false);
  const title = "Boostez Votre Visibilité Locale avec NLocale – Plateforme pour Pros de l'Aisne";
  const description = "Rejoignez NLocale, la plateforme dédiée aux professionnels de l'Aisne. Attirez des clients qualifiés grâce à une vitrine digitale engageante et intuitive.";
  const canonicalUrl = "https://onarrivebientot.nlocale.fr/pro";

  return (
    <>
      <ProPageSEO
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
      />
      <main className="bg-gradient-to-b from-white to-gray-50 min-h-screen flex flex-col">
        <ProPageContent
          showWaitlist={showWaitlist}
          setShowWaitlist={setShowWaitlist}
        />
      </main>
    </>
  );
};

export default Pro;
